import React, { useState } from 'react';

import moment, { Moment } from 'moment';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { updateEmployee } from '../actions/update-employee';

import { UiButton } from '../../ui/ui-button';
import { UiDatePicker } from '../../ui/ui-date-picker';
import { UiDialog } from '../../ui/ui-dialog';

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  { employee }: InputProps,
) => ({
  actions: {
    updateEmployee: (update: Partial<EmployeeUpdateRequest>) =>
      dispatch(updateEmployee(employee.employeeId, update)),
  },
});

type InputProps = {
  employee: Employee;
  onClose: () => void;
};

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & DispatchProps;

export const EmployeeRehireDialog = connect(
  null,
  mapDispatchToProps,
)(({ actions, employee, onClose }: Props) => {
  const [newStartDate, setNewStartDate] = useState<Moment | null>(
    employee.startDate ? moment(employee.startDate) : moment(),
  );
  const [startDateError, setStartDateError] = useState<string | null>(null);
  const [isUpdating, setIsUpdating] = useState<boolean>(false);
  const isInvalid = Boolean(startDateError);
  const { firstName } = employee.Contact.Person;

  const handleStartDateChange = (date: Moment | null) => {
    setNewStartDate(date);
  };

  const handleStartDateError = (error: string | null) => {
    setStartDateError(error);
  };

  const handleRehireClick = async () => {
    setIsUpdating(true);
    await actions.updateEmployee({
      startDate: newStartDate,
      isCurrentEmployee: true,
      endDate: null,
      endReasonId: null,
      endReasonExplanation: null,
    });
    onClose();
  };

  return (
    <UiDialog onClose={onClose} size="xs" title="Rehire Employee">
      <UiDialog.Content>
        {employee.startDate
          ? `Our automations are triggered based on start date. You can update ${firstName}'s below or keep it the same.`
          : `Do you want to set a start date for ${firstName}?`}
        <div className="u-margin-top u-display-flex u-justifyContent-center">
          <UiDatePicker
            label="Start Date"
            noDateCheckboxLabel="I don't know the start date"
            onChange={handleStartDateChange}
            onError={handleStartDateError}
            defaultDate={newStartDate}
          />
        </div>
      </UiDialog.Content>
      <UiDialog.Actions>
        <UiButton variant="dismiss" onClick={onClose}>
          Cancel
        </UiButton>
        <UiButton
          disabled={isUpdating || isInvalid}
          onClick={handleRehireClick}
          loading={isUpdating}
        >
          Rehire
        </UiButton>
      </UiDialog.Actions>
    </UiDialog>
  );
});
